{
    "ReportlistMyreportlist": "Il mio elenco di rapporti",
    "ReportlistAddreport": "Aggiungi rapporto",
    "ReportlistDeletereport": "Cancellare il rapporto",
    "ReportlistMoreoptions": "Altre opzioni",
    "ReportlistModifyreport": "Modificare il rapporto",
    "ReportlistCopyreport": "Rapporto di copia",
    "ReportlistRenamefolder": "Rinominare la cartella",
    "ReportlistRenamereport": "Rinominare il rapporto",
    "NoreportsconfiguredText": "Nessun rapporto configurato.",
    "ReportlistRecyclebin": "Cestino",
    "ReportlistEmptyrecyclebin": "Svuotare il cestino",
    "ReportlistRestoreallreports": "Ripristino di tutti i rapporti",
    "ReportlistRestorereport": "Rapporto di ripristino",
    "ReportlistDeletereportsinfolder": "Cancellare il contenuto della cartella",
    "ReportlistRestorereportsinfolder": "Ripristino del contenuto della cartella",
    "ReportlistNotAllCompleted": "{} dei {} rapporti selezionati sono stati spostati nel cestino.",
    "ReportlistOutof": "fuori da",
    "ReportlistNoreportswererestored": "Non è stato ripristinato alcun rapporto.",
    "ReportlistReportwasrestored": "Il rapporto è stato ripristinato.",
    "ReportlistReportswererestored": "{I rapporti sono stati ripristinati.",
    "ReportlistXoutofyselectedreportswererestored": "Sono stati ripristinati {} dei {} rapporti selezionati.",
    "ReportlistRestoregenericfailurereason": "I rapporti non riusciti potrebbero essere già stati ripristinati o eliminati definitivamente.",
    "ReportlistNoreportsweremovedtobin": "Nessuna segnalazione è stata spostata nel cestino.",
    "ReportlistReportwasmovedtobin": "Il rapporto è stato spostato nel cestino.",
    "ReportlistReportsweremovedtobin": "{I rapporti sono stati spostati nel cestino.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} dei {} rapporti selezionati sono stati spostati nel cestino.",
    "ReportlistMovetobingenericfailurereason": "I rapporti non riusciti potrebbero essere già stati spostati nel cestino.",
    "ReportlistThirtydaysremaining": "Il contenitore rimarrà nel bidone del riciclaggio per 30 giorni o fino a quando non sarà svuotato.",
    "ReportlistBeendeleted": "è stato eliminato.",
    "ReportlistNoreportsweredeletedpermanently": "Nessuna segnalazione è stata cancellata in modo permanente.",
    "ReportlistReportwasdeletedpermanently": "Il rapporto è stato cancellato definitivamente.",
    "ReportlistReportsweredeletedpermanently": "I rapporti {} sono stati eliminati in modo permanente.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} dei {} rapporti selezionati sono stati eliminati in modo permanente.",
    "ReportlistDeletepermanentlygenericfailurereason": "I rapporti non riusciti potrebbero essere già stati eliminati o ripristinati in modo permanente e non più presenti nel cestino.",
    "ReportlistMoveToBinCondition": "In futuro, non mostratemi questa finestra di dialogo.",
    "ReportlistNoreportswerecopied": "Non sono stati copiati rapporti.",
    "ReportlistReportwascopied": "Il rapporto è stato copiato.",
    "ReportlistReportswerecopied": "{I rapporti sono stati copiati.",
    "ReportlistXoutofyselectedreportswerecopied": "Sono stati copiati {} dei {} rapporti selezionati.",
    "ReportlistCopygenericfailurereason": "I rapporti non riusciti potrebbero essere già stati spostati nel cestino.",
    "NAME": "LanguageMyReportList",
    "ReportlistAdddefaultreport": "Aggiungi rapporto predefinito",
    "ReportListCopyReportsSuccessfulMessage": "Copiati con successo {} rapporti",
    "ReportlistOverrideExistingReport": "Spuntare se si desidera sovrascrivere i Rapporti esistenti.",
    "ReportlistReportsKeptForThirtyDays": "I rapporti sovrascritti vengono conservati nel Cestino per 30 giorni o finché non vengono svuotati."
}